import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  config.headers["X-User-Id"] = localStorage.getItem("zk_user_id") || "demo-werknemer";
  const token = localStorage.getItem("zk_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// Sessieverval: centrale 401-afhandeling. UserContext registreert hier een handler die
// de gebruiker netjes terugstuurt naar het inlogscherm i.p.v. een runtime-error te tonen.
let onSessionExpired = null;
export const setSessionExpiredHandler = (fn) => { onSessionExpired = fn; };

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/");
    // Alleen ingelogde (token aanwezig) sessies buiten de auth-endpoints afvangen.
    if (status === 401 && !isAuthEndpoint && localStorage.getItem("zk_token")) {
      // Technische details uitsluitend naar de console (niet naar de eindgebruiker).
      console.warn("[sessie-verval] 401", {
        endpoint: url, status, timestamp: new Date().toISOString(),
        user: localStorage.getItem("zk_user_id") || null,
      });
      localStorage.removeItem("zk_token");
      if (onSessionExpired) onSessionExpired();
      // Stil afbreken: geen afwijzing die een overlay/dubbele foutmelding veroorzaakt.
      // De app schakelt direct over naar het inlogscherm.
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default api;
